
<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>研究生申请列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索 -->
    <div class="content">
      <el-form
        inline
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="getList()"
      >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selClick();">查询</el-button>
        </el-form-item>
      </el-form>

      <!-- 主体 -->
      <el-card class="box-card table">
        <div class="clearfix" slot="header">
          <span>研究生</span>
        </div>

        <!-- 列表 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width:100%"
          @sort-change="sortChange"
          @filter-change="filterTag"
        >
          <el-table-column prop="nickName" label="姓名"></el-table-column>
          <el-table-column prop="mobile" label="电话"></el-table-column>
          <el-table-column prop="wechat" label="微信"></el-table-column>
          <el-table-column prop="qq" label="QQ"></el-table-column>
          <el-table-column prop="eduBack" label="学历"></el-table-column>
          <el-table-column prop="english" label="英语水平"></el-table-column>
          <el-table-column prop="japanese" label="日语水平"></el-table-column>
          <el-table-column prop="graduationTime" label="毕业时间"></el-table-column>
          <el-table-column prop="deviceName" label="终端类型"></el-table-column>
          <el-table-column prop="createTime" label="申请时间"></el-table-column>

          <!-- 操作 -->
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="标记处理" placement="top">
                  <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-check"
                    @click="checkClick(scope.row)"
                    v-if="scope.row.handleState==1"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination
            background
            @size-change="handlSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10,20,30,50,100]"
            :page-size="pageSize"
            layout="total,sizes,prev,pager,next,jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      query: {},
      form: {},
      dialogVisible: false,
      loading: false,
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage4: 1
    };
  },
  methods: {
    handlSizeChange: function(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange: function(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //   筛选
    filterTag: function(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      this.getList();
    },
    //   排序
    sortChange: function(sortColumn) {
      this.query.sort = sortColumn.sort;
      this.query.order = sortColumn.order;
      this.getList();
    },
    // 列表
    getList: function() {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageIndex = _this.currentPage4;
      params.pageSize = _this.pageSize;
      var link = url.getBaseData("getlist_graduate");
      $.get(link, params, data => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    // 搜索
    selClick: function() {
      this.currentPage4 = 1;
      this.getList();
    },
    // 标记处理
    checkClick: function(row) {
      var _this = this;
      var id = row.id;
      var link = url.getBaseData("handle_graduate");

      this.$confirm("确定要处理吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "arning"
      })
        .then(() => {
          $.post(link, { id: id }, res => {
            if (res.status) {
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消处理"
          });
        });
    }
  },
  mounted() {
    //   列表
    this.getList();
  }
};
</script>